import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Reveal, RevealGroup } from "@/components/Reveal";
import PestCard from "@/components/PestCard";
import PestJump from "@/components/PestJump";
import { DuckSays } from "@/components/DuckMascot";
import { PESTS } from "@/data/pests";

export default function PestsIndex() {
  return (
    <div data-testid="pests-index-page">
      <Seo
        title="Pest Library"
        description="Browse the DuckTheBugs pest library — mosquitoes, ticks, wasps, ants, fleas, and rodents. Identify the problem, decide DIY vs pro, and learn what treatment involves."
        path="/pests"
      />
      <section className="bg-forest-950 text-cream grain pt-[72px]">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 md:py-24">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Pests" }]} />
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-black text-cream leading-[1.02] max-w-3xl">
            The pest library
          </h1>
          <p className="mt-5 text-lg text-cream/80 max-w-2xl leading-relaxed">
            Every pest is a little different — some are a weekend DIY fix, some are a clear call-a-pro moment. Start with what's bugging you and we'll walk you through it honestly.
          </p>
          <PestJump variant="dark" className="mt-8" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 md:py-20">
        <RevealGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PESTS.map((p) => (
            <PestCard key={p.slug} pest={p} />
          ))}
        </RevealGroup>

        <Reveal>
          <div className="mt-14 rounded-3xl bg-sand p-8 sm:p-10">
            <DuckSays label="Not sure?">
              Can't tell what you're dealing with? That's genuinely common. Start the Find-a-Pro flow and choose "Not
              sure" — describing what you're seeing is often enough to point you the right way.
            </DuckSays>
            <Link to="/hire-a-pro" className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-terracotta text-white font-semibold hover:bg-terracotta/90 transition-all" data-testid="pests-not-sure-cta">
              Help me identify it
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
